'use client';

import UnifiedSplashScreen from '@/components/shared/UnifiedSplashScreen';

export default function Loading() {
  // Use the unified splash screen for consistent branding
  return <UnifiedSplashScreen visible={true} message="Loading..." />;
}
